import React from 'react';
import "tabler-react/dist/Tabler.css";
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import './index.sass'

// Pages
import Home from '../../Pages/Home';
import EditForm from "../../Pages/Edit/index";
import Subscriptions from "../../Pages/Subscriptions/index";
import SubscriptionDetails from "../../Pages/SubscriptionDetails/index";
import ChangeEmail from "../../Pages/ChangeEmail/index";
import ChangePhone from "../../Pages/ChangePhone/index";
import ChangeAddress from "../../Pages/ChangeAddress/index";
import ChangePassword from "../../Pages/ChangePassword/index";
import NotFound from "../../Pages/NotFound/index";
import Login from '../../Pages/Login';
import ForgotPassword from '../../Pages/ForgotPassword';
import NewSubscription from '../../Pages/NewSubscription';
import CreditCard from '../../Pages/CreditCard';
import Stats from '../../Pages/Stats';
import ActivateCode from '../../Pages/ActivateCode';
import FreeSubscription from '../../Pages/FreeSubcription';
import FreeActivation from '../../Pages/FreeActivation';

const App = () => {
    return (
        <Router>
            <Switch>
                <Route exact={true} path="/" component={Login} />
                <Route exact={true} path='/forgot-password' component={ForgotPassword} />
                <Route exact={true} path='/home' component={Home} />
                <Route exact={true} path='/stats' component={Stats} />
                <Route exact={true} path='/edit' component={EditForm} />
                <Route exact={true} path='/credit-card/new' component={CreditCard} />
                <Route exact={true} path='/subscriptions' component={Subscriptions} />
                
                <Route exact={true} path='/subscriptions/new' component={NewSubscription} />
                <Route exact={true} path='/subscriptions/free' component={FreeSubscription} />
                <Route exact={true} path='/subscriptions/:id' component={SubscriptionDetails} />
                <Route exact={true} path='/change-email' component={ChangeEmail} />
                <Route exact={true} path='/change-phone' component={ChangePhone} />
                <Route exact={true} path='/change-address' component={ChangeAddress} />
                <Route exact={true} path='/change-password' component={ChangePassword} />
                <Route exact={true} path='/logout' component={Logout} />
                <Route exact={true} path='/freeactivation/:code' component={FreeActivation} />
                <Route component={NotFound} />
            </Switch>
        </Router>
    );
};

const Logout = (props) => {

    sessionStorage.removeItem('ooppah_user_info');
    sessionStorage.removeItem('ooppah_user_token');

    window.location = '/';

    return(<div className="m-2">Signing out...</div>);
};

export default App;
